import React from 'react'
import ProductItemCollection from './productItemCollection'
import ScreenSizes from '../../../../configTools/screenSizes';

const ProductGrid4 = ({Products,Columns}) => {
  const widths = window.innerWidth;
  return (
    <div className='public_home_product_grid_1_container'>
      <div className='public_home_product_grid_4_products'>
        {
            Products.map((product,index)=>{
                return(
                    <div style={widths > ScreenSizes.Mobile? {width:String((100/(parseInt(Columns))))+"%", padding:"0.1%"} : {width:"33.33%", padding:"0.1%"} } key={index}>
                        <ProductItemCollection Product={product} />
                    </div>
                )
            })
        }
      </div>
    </div>
  )
}

export default ProductGrid4
